// extracted by mini-css-extract-plugin
export default {"menu":"CustomDropdown_menu__MJY9D","toggle":"CustomDropdown_toggle__k0GKM"};